module.exports = __webpack_public_path__ + "static/media/ZylaandKai.405801a3.jpg";